import React, {useContext, useState} from "react";
import {Query} from "../../../containers/QueryBuilder/types/Query";
import {QueryBuilderContext, QueryBuilderContextType} from '../QueryBuilderContext';
import styles from './FilterDetails.module.scss';
import {CaretRightOutlined, CaretUpOutlined} from '@ant-design/icons';
import {ReactComponent as FilterDetailsIcon} from '../icons/FilterDetails.svg';

export const FILTER_DETAILS_PREFIX = 'Filter Details:'
export const FILTER_DETAILS_ID = 'filter-details'
export const FILTER_DETAILS_CSV_ID = 'filter-details-csv'
export const DEFAULT_FILTERS_COUNT = 5

export const filterText = (query: Query) => {
    const content = [
        <b key="label">
            <FilterDetailsIcon className={styles.filterDetailsIcon} />
            &nbsp;{FILTER_DETAILS_PREFIX}
        </b>
    ]
    if (query.filterLabels && query.filterLabels.length > 0) {
        query
            .filterLabels
            .forEach(fi => {
                // TODO: handle filters associated with a parent filter
                const length = fi.values.length
                content.push(<b key={`${fi.field}-filter-title`}>{` ${fi.title}: `}</b>)
                const values = fi
                    .values
                    .flatMap((value, i, array) => {
                        const label = <span key={`${fi.field}-filter-value-${i}`}>{value}</span>
                        if (i === 0) {
                            return [label]
                        } else if (i === length - 1) {
                            return [<span key={`${fi.field}-filter-join-&-${i}`}> & </span>, label]
                        } else {
                            return [<span key={`${fi.field}-filter-join-,-${i}`}>, </span>, label]
                        }
                    })
                content.push(...values)
            })
    } else {
        const hasFilters = query.filters && query.filters.length > 0
        const hasNoFilterLabels = !query.filterLabels
        if (hasFilters && hasNoFilterLabels) {
            content.push(<span key={'none'} style={{color: 'red'}}> Previously applied filters on this query have now become out of date. Please reapply the filters and rerun the query.</span>)
        } else {
            content.push(<span key={'none'}> None</span>)
        }
    }
    return content
}

export const FilterDetails = () => {
    const { userQuery } = useContext(QueryBuilderContext) as QueryBuilderContextType
    const allFilters = filterText(userQuery.query)

    const [visibleFiltersCount, setVisibleFiltersCount] = useState(DEFAULT_FILTERS_COUNT);
    const [isExpanded, setIsExpanded] = useState(false);

    const expandFilters = () => {
        if (allFilters.length !== 2) {
            setVisibleFiltersCount(allFilters.length)
            setIsExpanded(true)
        }
    }

    const collapseFilters = () => {
        setVisibleFiltersCount(DEFAULT_FILTERS_COUNT)
        setIsExpanded(false)
    }

    return (
        <>
        <div className={styles.hidden} data-testid={FILTER_DETAILS_CSV_ID}>{allFilters}</div>
        <div className={styles.container} data-testid={FILTER_DETAILS_ID}>

            {isExpanded ?
                allFilters.slice(0, allFilters.length) :
                allFilters.slice(0, visibleFiltersCount)
            }

            {(allFilters.length > DEFAULT_FILTERS_COUNT) ?
                ((visibleFiltersCount <= DEFAULT_FILTERS_COUNT) ?
                        <button data-testid="expand-button" className={styles.toggle} onClick={expandFilters}>... Expand {<CaretRightOutlined className={styles.icon}/>}</button> :
                        <button data-testid="collapse-button" className={styles.toggle} onClick={collapseFilters}>Collapse {<CaretUpOutlined className={styles.icon}/>}</button>
                ) : null
            }

        </div>
        </>
    )
}